import { Http, Response } from '@angular/http';
import { Injectable } from '@angular/core';
import * as Config from "../../app/app.config";
import { AuthProvider } from "../auth/auth";

@Injectable()
export class TitleProvider {

  constructor(
    public http: Http,
    private auth: AuthProvider
  ) {
    console.log('Hello TitleProvider Provider');
  }

  public getTitles() {
    let headers = this.auth.createApplicationHeadersWithBearer();

    return this.http
      .get(Config.baseUrl + '/titles/gettitles', { headers: headers })
      .map((res: Response) => res.json());
  }

  public getCategories() {
    let headers = this.auth.createApplicationHeadersWithBearer();

    return this.http
      .get(Config.baseUrl + '/titles/categories', { headers: headers })
      .map((res: Response) => res.json());
  }

  public getSubcategories(categoryId: number) {
    let headers = this.auth.createApplicationHeadersWithBearer();

    return this.http
      .get(Config.baseUrl + `/titles/categories/${categoryId}/subcategories`, { headers: headers })
      .map((res: Response) => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/providers/title/title.ts